import type { ConversationQuestion, Perspective } from "@samklang/schemas";
import { resolveQuestionWording } from "@samklang/conversation-engine";
import type { CommunicationPreferences } from "@/stores/conversation-store";

export interface QuestionPresentation {
  readonly title: string;
  readonly supportText: string | undefined;
  readonly visualSupport: boolean;
  readonly fewerOptions: boolean;
}

function simplifySwedishQuestion(title: string): string {
  return title
    .replace(/\bjust nu\b/gi, "nu")
    .replace(/\bbrukar\b/gi, "")
    .replace(/\boftast\b/gi, "")
    .replace(/\s{2,}/g, " ")
    .replace(/\s+\?/g, "?")
    .trim();
}

export function questionPresentation(question: ConversationQuestion, preferences: CommunicationPreferences, perspective?: Perspective): QuestionPresentation {
  const shortest = preferences.shortestWording || preferences.communicationLevel === "enkel";
  const baseTitle = resolveQuestionWording(question, {
    communicationLevel: preferences.communicationLevel,
    ...(perspective ? { perspective } : {}),
    shortest,
  });
  return {
    title: preferences.communicationLevel === "enkel" ? simplifySwedishQuestion(baseTitle) : baseTitle,
    supportText: preferences.extraExamples ? question.supportText : undefined,
    visualSupport: preferences.visualSupport,
    fewerOptions: "options" in question && question.options.length > 8,
  };
}
